import * as React from 'react';

import { Icon } from '@gitbook/spine-icons';
import {
    ActionableContainer,
    Button,
    confirm,
    Description,
    Group,
    Heading,
    toast,
} from '@gitbook/spine-react';

import { useNavigation } from '../../../../../navigation';
import { apiClient, useSiteContext } from '../../../../../state';

export const DeleteSite = React.memo(function DeleteSite() {
    const { site, organizationId } = useSiteContext();
    const { navigate } = useNavigation();

    return (
        <ActionableContainer orientation="horizontal">
            <Group>
                <Heading>Delete site</Heading>
                <Description>
                    Your site will be removed, any pre-existing subscriptions will continue until
                    the completion date.
                </Description>
            </Group>
            <Button
                kind="danger"
                size="medium"
                leadingIcon={Icon.Trashcan}
                label="Delete site"
                disabled={site.published}
                tooltip={
                    site.published
                        ? { label: 'You must unpublish this site before deleting it.' }
                        : undefined
                }
                onPress={() => {
                    void confirm({
                        title: 'Delete site?',
                        description:
                            'Your docs site will be deleted and visitors will no longer be able to access it. Deleting a docs site also deletes any settings and customization applied to the site. No space content will be deleted.',
                        kind: 'danger',
                        confirmLabel: 'Delete',
                        onConfirm: async (_event, { preventClose }) => {
                            await toast.catch(
                                async () => {
                                    await apiClient.sites.deleteSiteById(organizationId, site.id);
                                    navigate({
                                        screen: { type: 'home', organization: organizationId },
                                    });
                                    toast.success('Site deleted');
                                },
                                'Error while deleting site',
                                { onReject: preventClose }
                            );
                        },
                    });
                }}
            />
        </ActionableContainer>
    );
});
